import { useState, useEffect, useRef } from "react"
import nodeApiService from "../../services/nodeApiService"
import styles from "../../features/pages/ArtworkDetailPage/ArtworkDetailPage.module.css"

export const useArtworkDetailsActions = (artwork, insertArplacerButtons) => {
  const recaptchaRef = useRef()
  const [form, setForm] = useState({
    email: "",
    firstname: "",
    lastname: "",
    body: "",
  })
  const [modal, setModal] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const [success, setSuccess] = useState(false)

  const handleClose = () => {
    setModal(false)
    setTimeout(() => {
      setSuccess(false)
    }, 500)
  }
  const handleShow = () => {
    setSuccess(false)
    setModal(true)
  }
  const onSubmit = (event) => {
    event.preventDefault()
    recaptchaRef.current.execute()
  }
  const successCallback = () => {
    setSuccess(true)
    setForm({
      email: "",
      firstname: "",
      lastname: "",
      body: "",
    })
  }
  const onReCAPTCHAChange = async (captchaCode) => {
    if (!captchaCode) {
      return
    }
    setError(false)
    nodeApiService
      .inquire(artwork.id, {
        ...form,
        captcha: captchaCode,
        channel: "discover",
        type: "artwork_inquiry_discover",
      })
      .then(
        (_) => {
          successCallback()
        },
        (res) => {
          setError(true)
          setErrorMessage(res.response.data.errorMessage)
        },
      )
    recaptchaRef.current.reset()
  }

  // insertArplacerButtons must be memoized by the caller: an inline function
  // would re-insert the widget buttons on every render.
  // Deferred so rapid changes collapse into one insert and the widget's own
  // pending (setTimeout 0) insert lands before our clear, avoiding duplicates.
  useEffect(() => {
    if (!insertArplacerButtons) return
    const timer = setTimeout(insertArplacerButtons, 0)
    return () => clearTimeout(timer)
  }, [insertArplacerButtons])

  return {
    form,
    setForm,
    modal,
    handleClose,
    handleShow,
    onSubmit,
    error,
    errorMessage,
    success,
    onReCAPTCHAChange,
    recaptchaRef,
  }
}
